import { Chip } from 'primereact/chip';
import React from 'react';

export const getUserRole = (role: string) => {
    if (role === 'agent') return 'agent';
    else if (role === 'Supervisor 1' || role === 'Supervisor 2') return 'supervisor';
    else if (role === 'Manager 1' || role === 'Manager 2') return 'manager';
    else if (
        role !== 'Non-Manager' &&
        role !== 'Supervisor 1' &&
        role !== 'Supervisor 2' &&
        role !== 'Manager 1' &&
        role !== 'Manager 2'
    )
        return 'other';
    else return '';
};
export const allowExpansion = (rowData: any) => {
    if (rowData) return true;
    else return false;
};
export const valueBodyTemplate = (rowData: any) => {
    return (
        <div>
            {rowData.core_value_id === 1 && (
                <Chip label={rowData.core_value_name} style={{ backgroundColor: '#3299FF', color: 'white' }} />
            )}
            {rowData.core_value_id === 2 && (
                <Chip label={rowData.core_value_name} style={{ backgroundColor: '#A9A5FF', color: 'white' }} />
            )}
            {rowData.core_value_id === 3 && (
                <Chip label={rowData.core_value_name} style={{ backgroundColor: '#FF9933', color: 'white' }} />
            )}
            {rowData.core_value_id === 4 && (
                <Chip label={rowData.core_value_name} style={{ backgroundColor: '#FABB00', color: 'white' }} />
            )}
            {rowData.core_value_id === 5 && (
                <Chip label={rowData.core_value_name} style={{ backgroundColor: '#EB419E', color: 'white' }} />
            )}
            {rowData.core_value_id === 6 && (
                <Chip label={rowData.core_value_name} style={{ backgroundColor: '#2AA154', color: 'white' }} />
            )}
        </div>
    );
};

export const startBodyTemplate = (rowData: any) => {
    if (rowData.start_date) {
        const startDate = new Date(rowData.start_date);

        const day = startDate.getDate().toString().padStart(2, '0');
        const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(startDate);
        const year = startDate?.getFullYear();

        const formattedDueDate = `${day}-${month}-${year}`;

        return <div>{formattedDueDate}</div>;
    } else {
        return <div>no Date</div>;
    }
};

export const GetTeamOptions = () => {
    const teamOptions: any = [];
    //teamOptions.push({ name: 'My Shout Out', code: 'myshoutout' });
    //if (role !== 'Non-Manager')
        teamOptions.push({ name: 'My Team', code: 'myteam' },{ name: 'Search', code: 'search' });
    return teamOptions;
}
export const getRole = (role: string,isPseudoSupervisor:boolean) => {

    if (isPseudoSupervisor===true) return 'supervisor';

    if (role === 'Non-Manager') return 'associate';
    else if (role === 'Supervisor 1' || role === 'Supervisor 2') return 'supervisor';
    else if (role === 'Manager 1' || role === 'Manager 2') return 'manager';
    else if (role !== '' && role !== 'Non-Manager' && role !== 'Supervisor 1'&& role !== 'Supervisor 2'&& role !== 'Manager 1'&& role !== 'Manager 2') return 'manager';
    else return '';
}